<section class="banner">
    <div class="container-fluid bg mt-5">
        <div class="container mt-lg-5 ">
            <div class="d-flex flex-lg-row flex-column-reverse g-5">
                <div class="col-lg-6 d-flex text-center text-lg-start align-items-center">
                    <div class="px-2 pt-3 pt-lg-0">
                        <h1 class="fw-bolder ">
                            <span class="d-lg-block d-none font-56">
                                  <span class="brand-primary-text-color">CGMS-</span>
                            The Ultimate Tool for Managing College Groups
                            </span>
                            <span class="d-lg-none ">
                                  <span class="brand-primary-text-color">CGMS-</span>
                            The Ultimate Tool for Managing College Groups
                            </span>
                        </h1>
                        <p class="my-lg-4 text-secondary text-wrap f-20 justify-text">The College Group Management
                            System helps your
                            institute to work in a more
                            advanced way. It enhances collaboration and engagement among learners and faculty involved
                            in
                            various campus groups. The CGMS system is a group collaboration software that aims to
                            enhance
                            communication, coordination, and collaboration.
                        </p>
                        <button class="btn bg-white border-0 px-5 rounded-0 fw-bold hover-effect"
                                (click)="openModal()">View Demo <i
                            class="ms-3 fa-solid fa-arrow-right"></i>
                        </button>
                        <ng-template #contactFormModal>
                            <app-contact-form [isModalOpen]="isModalOpen"
                                              (closeModal)="closeModal()"></app-contact-form>
                        </ng-template>
                        <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                            <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 d-flex justify-content-end py-lg-5 py-2 px-lg-3 d-flex justify-content-center">
                    <div class="position-relative">
                        <img src="assets/img/landing-new/thumbnail/cgms-thumbnail.webp"
                             class="img-fluid rounded-4" alt="College Group Management Systemr Image" id="video-thumbnail">
                        <button class="play-button position-absolute" (click)="playVideo()"></button>
                        <video #videoElement class="d-none rounded-4 w-100" controls>
                            <source src="assets/img/landing-new/cgms/cgms.webm" type="video/webm">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid">
    <div class="container py-5">
        <div class="row ">
            <div class="col-lg-6 d-flex align-items-center text-right">
                <div class="card  rounded-4   d-flex justify-content-center border-0 shadow-lg">
                    <div class="card-body">
                        <img src="assets/img/landing-new/cgms/About Volmint’s College Group Management System.webp" class="mt-2" alt="College Group Management System">
                    </div>
                </div>
            </div>
            <div class="col-lg-6 ps-lg-5 py-md-5 py-3">
                <h2 class=" fs-1 fw-bolder">About Volmint’s
                    <span class="brand-primary-text-color"> College Group Management System</span></h2>
                <p class="my-lg-4 text-secondary text-wrap justify-text">A College Group Management System is
                    a sophisticated
                    software solution designed to
                    enhance the organizational efficiency of group-related activities within an educational institution.
                    Created for colleges and universities, this system serves as a centralized platform for coordinating
                    and optimizing the functioning of various student groups, clubs, and organizations on campus. It
                    facilitates seamless communication, collaboration, and coordination among group members, faculty
                    advisors, and administrators.</p>
                <img src="assets/img/project/cms-two.png" class="mt-5 d-none d-lg-block" alt="College Group Management System">
            </div>
        </div>
        <div class="d-flex flex-lg-row flex-column-reverse gap-3 gap-lg-5 align-items-center">
            <div class="col-lg-6 py-lg-5">
                <h2 class=" fs-1 fw-bolder">Optimize Campus Efficiency with Our Robust
                    <span class="brand-primary-text-color">CGMS</span></h2>
                <p class="text-secondary text-wrap justify-text">Volmint’s College Group Management System
                    offers robust and
                    advanced software to
                    perform countless activities within an institution. It offers secure college data management along
                    with an academic team management system. CGMS software provides a centralized platform for faculty,
                    students, and administrative staff to communicate.
                </p>

                <div class="row g-3">
                    <div class="col-12 col-md-6  fw-bold text-center "
                         *ngFor="let item of powerfullToUse">
                        <div class="brand-primary-bg text-white  px-5 py-3 powerful-item">
                            {{ item.text }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pt-lg-5 text-right align-self-center">
                <img src="assets/img/landing-new/enroll/Streamline Admission Processes with the Power of Enroll (1).webp" class="mt-2" alt="College Group Management System">
            </div>
        </div>
    </div>
</div>
<div class="container-fluid bg-purple">
    <div class="container">
        <div class=" py-5 align-items-center d-flex flex-lg-row flex-column-reverse gap-3 gap-lg-5 align-items-center">

            <div class="col-lg-6">
                <h2 class=" fs-1 fw-bolder">
                    <span class="brand-primary-text-color">Key Features</span> College Group Management System</h2>
                <p class="my-lg-3 text-secondary text-wrap justify-text">A college group management system has
                    countless
                    collaborative tools for students and teachers. It automates several processes, reduces the manual
                    workload, and improves the college administration experience.
                </p>
                <div class="row g-3">
                    <div class="col-sm-4 col-6 px-2"
                         *ngFor="let item of features">
                        <div class="card bg-white text-center h-100 py-2 border-0 shadow-lg p-4 d-flex flex-wrap align-items-center justify-content-center">
                               <span>
                            <img src="{{item.icon}}" alt="College Group Management Systemss" class="img-fluid w-25">
                        </span>
                            <span class="ms-2 text-secondary">
                            {{ item.text }}
                        </span>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-lg-6  d-flex justify-content-center justify-content-lg-end">
                <img src="assets/img/landing-new/cgms/Key Features College Group Management System.webp" alt="College Group Management System">
            </div>
        </div>
    </div>
</div>
<div class="container-fluid">
    <div class="container">
        <div class="  align-items-center d-flex flex-lg-row flex-column-reverse gap-2 gap-lg-5 align-items-center">
            <div class="col-lg-6 py-lg-5">
                <h2 class=" fs-1 fw-bolder">
                    Manage <span class="brand-primary-text-color">Multiple Colleges </span> From Single Dashboard</h2>
                <p class=" text-secondary text-wrap justify-text">Volmint’s CGMS allows to manage and
                    control multiple
                    colleges under the roof of a single platform. It creates a collaborative approach for the different
                    users and members to work smoothly and effectively.</p>
                <button class="btn text-white brand-primary-bg border px-5 rounded-0  hover-white fw-bold"
                        (click)="openModal()">Book Appointment
                    <i
                        class="ms-3 fa-solid fa-arrow-right"></i>
                </button>
            </div>
            <div class="col-lg-6 pt-5 text-start text-lg-right">
                <img src="assets/img/landing-new/cgms/Manage Multiple Colleges From Single Dashboard.webp" class=" mt-lg-2" alt="College Group Management System">
            </div>
        </div>
        <div class="row ">
            <div class="col-lg-6 pt-5   text-lg-right">
                <img src="assets/img/landing-new/cgms/Why Do You Need CGMS Software.webp" class="ms-lg-2 mt-2" alt="College Group Management System">
            </div>
            <div class="col-lg-6 py-3 py-lg-5 ps-lg-5">
                <h2 class=" fs-1 fw-bolder">
                    Why Do You Need <span class="brand-primary-text-color">CGMS Software </span></h2>
                <p class="my-lg-3 text-secondary text-wrap justify-text">College Group Management Software is
                    essential for
                    efficient organization and coordination within educational institutions. It streamlines various
                    aspects of group activities, fostering collaboration and enhancing productivity.</p>

                <div class="row  ">
                    <div class="col-sm-6 col-12 px-0 px" *ngFor="let item of offerings">
                        <div class="offer-item d-flex align-items-center p-4 rounded shadow-lg mx-auto">
      <span class="offer-icon">
        <img src="assets/img/project/check.png" alt="College Group Management System class" class="img-fluid">
      </span>
                            <span class="ms-4 offer-text fs-6 text-secondary">
        {{ item.text }}
      </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid brand-primary-bg mt-5">
    <div class="container py-5">
        <h2 class="fs-1 text-white text-lg-center  fw-bold">What Makes Our College Group Management System Stand Out</h2>
        <p class="text-white text-lg-center justify-text">Volmint College Group Management System (VCGM) stands out
            as a
            comprehensive
            cloud-based solution, revolutionizing college administration. Here are compelling reasons to choose us:
        </p>
        <div class="row gy-4 gy-lg-5 py-lg-5">
            <div class="col-lg-4 col-md-6 px-3" *ngFor="let item of whyChoose; let i = index">
                <div class="d-flex align-items-center gap-2">
                    <div>
                        <div
                            class="h-w-40 text-center rounded-circle bg-white fw-bold text-black d-flex align-items-center justify-content-center ">{{ i + 1 }}
                        </div>
                    </div>

                    <div>
                        <h3 class="my-2 fs-5 text-white fw-bold">{{ item.header }}</h3>

                    </div>
                </div>
                <p class="text-white justify-text">{{
                        item.text
                    }}</p>
            </div>

        </div>
    </div>
</div>

<div class="container-fluid py-lg-5">
    <div class="container">
        <div class="align-items-center d-flex flex-lg-row flex-column-reverse  gap-lg-5 align-items-center">

<!--        <div class="row py-5 gx-5">-->
            <div class="col-lg-7 py-lg-5">
                <h2 class=" fs-1 fw-bolder">Explore Our Comprehensive
                    <span class="brand-primary-text-color">CGMS Modules </span>
                </h2>
                <p class="my-lg-3 text-secondary text-wrap justify-text">Volmint College Group Management
                    Software offers prominent
                    modules, designed precisely for the needs and requirements of the institute, students, and
                    faculty.</p>

                <div class="row  ">
                    <div class="col-sm-6 col-12 px-0 px" *ngFor="let item of modules">
                        <div class="offer-item d-flex align-items-center p-4 rounded shadow-lg">
      <span class="offer-icon">
        <img src="assets/img/project/check.png" alt="College Group Management System class" class="img-fluid">
      </span>
                            <span class="ms-4 offer-text fs-6 text-secondary">
        {{ item.text }}
      </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 pt-lg-5 d-flex justify-content-center justify-content-end">
                <img src="assets/img/project/CGMS.jpg" class="img-fluid" alt="College Group Management System">
            </div>
        </div>
    </div>
</div>

<div class="container-fluid mt-5">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-6">
                <div class="">
                    <img src="assets/img/landing-new/contact-us/faq.png" alt="Admission Management System"
                         class="img-fluid d-none d-lg-block"/>
                    <h2 class="fw-bold text-center mt-lg-4 mt-lg-0 fs-2 text-lg-start text-secondary">Frequently Asked Questions</h2>
                    <p class="text-secondary d-none d-lg-block">Have a question that is not answered? You can contact us at</p>
                    <p class="brand-primary-text-color d-none d-lg-block fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                                            class="text-decoration-underline brand-primary-text-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="d-none d-lg-block brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-lg-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <span class="fs-6 fw-bold" style="color: #5236FF;">  <div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; What can Volmint’s College Group Management System (CGMS) do for our campus?</span>
                            </button>
                        </h3>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Volmint’s CGMS centralizes and streamlines all group-related activities, enhancing
                                communication and collaboration among students, faculty, and administrators. It
                                simplifies task management, automates processes, and ensures efficient coordination of
                                campus groups and clubs.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <span
                            class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; How does CGMS improve communication and collaboration on campus?</span>
                            </button>
                        </h3>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                CGMS offers advanced communication tools and real-time updates that keep everyone
                                connected and informed. Whether it’s through SMS, WhatsApp, or email, the system ensures
                                that all members of college groups are in sync and can collaborate effectively.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                <span class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; Is the CGMS secure and how does it handle sensitive information?</span>
                            </button>
                        </h3>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Yes, the CGMS prioritizes security with role-based login access, ensuring that only
                                authorized individuals can access sensitive data. This helps maintain confidentiality
                                and integrity of all information, protecting it from unauthorized access.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                <span class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; How does the CGMS assist with event management and promotion?</span>
                            </button>
                        </h3>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                The system includes tools for event promotion and marketing, making it easy to organize
                                and publicize campus events. This feature helps in managing events efficiently and
                                ensuring they reach the intended audience effectively.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                <span class="fs-6 fw-bold" style="color: #5236FF;"><div class="encircled-icon">
        <i class="fas fa-question fw-bold"></i>
    </div> &nbsp; What kind of support does Volmint offer for CGMS users?</span>
                            </button>
                        </h3>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Volmint provides 24/7 onsite and online support to address any technical issues quickly.
                                This ensures that the system remains reliable and fully operational, with assistance
                                available whenever needed.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid ums-bottom-bg ps-lg-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-lg-6 col-12 fs-2 color-white fw-bold mb-3 mb-lg-0 d-none d-lg-block">
                Trusted by Leading Colleges – Simplify Operations & Enhance Efficiency!
            </div>
            <div class="col-lg-6 col-12 text-center">
                <span class="fs-4 fw-bold mb text-white">Fill out the form, and we’ll be in touch soon!
                </span>
                <div class="bg-light-pink shadow py-5 mt-2 px-4">
                    <form [formGroup]="contactForm" class="">
                        <div class="mb-4 d-sm-flex g-3 mx">
                            <input type="name" class="form-control bg-white rounded-3 text-secondary me-sm-1 py-3" id="name"
                                   formControlName="name"
                                   placeholder="Enter Your Name" required>
                            <small *ngIf="submitted && contactForm.get('name').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                            <input type="email" class="form-control mt-3 mt-md-0 bg-white rounded-3 text-secondary py-3"
                                   id="email" formControlName="email"
                                   placeholder="Enter Your Email" required>
                            <small *ngIf="submitted && contactForm.get('email').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="mb-4">

                        </div>
                        <div class="mb-4">
                            <input type="tel" class="form-control bg-white rounded-3 text-secondary py-3"
                                   id="contact" formControlName="contact"
                                   placeholder="Enter Your Phone No." required>
                            <small *ngIf="submitted && contactForm.get('contact').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="mb-4">
                                <textarea class="form-control rounded-3 bg-white text-secondary" id="message"
                                          formControlName="message"
                                          rows="4" style="resize: none;"
                                          placeholder="Your Message" required></textarea>
                            <small *ngIf="submitted && contactForm.get('message').hasError('required')"
                                   class="text-danger">
                                Field is required.
                            </small>
                        </div>
                        <div class="text-center mt-4">
                            <button type="submit"
                                    class="bg-color-blue border-0  color-white px-5 py-2 w-50 fs-6 fw-bold hover-effect"
                                    (click)="submit()">
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
